

export enum AttributeUrlType {
	NONE = '',
	IMAGE = 'image',
	LINK = 'link'
}

